import * as React from "react";
import type { AuthControllerProps } from "./chrome/smart/auth-controller/auth-controller";

export const AuthControllerPropsContextHack = React.createContext<Omit<AuthControllerProps, "onLoggedIn"> | undefined>(
    undefined
);
